import { useEffect, useState } from "react";
import styles from "./VerticalCarousel.module.scss";
import useWindowDimensions, { CurrentScreen } from "../../../hooks/use-window-dimensions";

interface CarouselImage {
	src: string;
	alt: string;
}

const VerticalCarousel = () => {
	const [mounted, setMounted] = useState(false);
	const currentScreen: CurrentScreen = useWindowDimensions();

	useEffect(() => {
		setMounted(true);
	}, []);

	// Sample images for each column - you can replace with your actual images
	const leftColumnImages: CarouselImage[] = [
		{ src: "../../../../images/landing-page/carousel-1.png", alt: "Office collaboration 1" },
		{ src: "../../../../images/landing-page/carousel-2.png", alt: "Team meeting 1" },
		{ src: "../../../../images/landing-page/carousel-3.png", alt: "Workspace 1" },
		{ src: "../../../../images/landing-page/carousel-4.png", alt: "Professional setting 1" },
	];

	const middleColumnImages: CarouselImage[] = [
		{ src: "../../../../images/landing-page/carousel-4.png", alt: "Professional setting 1" },
		{ src: "../../../../images/landing-page/carousel-3.png", alt: "Workspace 1" },
		{ src: "../../../../images/landing-page/carousel-2.png", alt: "Team meeting 1" },
		{ src: "../../../../images/landing-page/carousel-1.png", alt: "Office collaboration 1" },
	];

	const rightColumnImages: CarouselImage[] = [
		{ src: "../../../../images/landing-page/carousel-1.png", alt: "Office collaboration 1" },
		{ src: "../../../../images/landing-page/carousel-2.png", alt: "Team meeting 1" },
		{ src: "../../../../images/landing-page/carousel-3.png", alt: "Workspace 1" },
		{ src: "../../../../images/landing-page/carousel-4.png", alt: "Professional setting 1" },
	];

	if (!mounted) {
		return <div className={styles.carousel}>Loading...</div>;
	}

	return (
		<div className={styles.carousel}>
			<div className={styles.column}>
				<div className={`${styles.imageTrack} ${styles.scrollDown}`}>
					{/* Duplicate images for seamless loop */}
					{[...leftColumnImages, ...leftColumnImages].map((image, index) => (
						<div key={index} className={styles.imageContainer}>
							<img src={image.src || "/placeholder.svg"} alt={image.alt} className={styles.image} />
						</div>
					))}
				</div>
			</div>

			<div className={styles.column}>
				<div className={`${styles.imageTrack} ${styles.scrollUp}`}>
					{/* Duplicate images for seamless loop */}
					{[...middleColumnImages, ...middleColumnImages].map((image, index) => (
						<div key={index} className={styles.imageContainer}>
							<img src={image.src || "/placeholder.svg"} alt={image.alt} className={styles.image} />
						</div>
					))}
				</div>
			</div>

			 {!currentScreen.isMobile  && <div className={styles.column}>
				<div className={`${styles.imageTrack} ${styles.scrollDown}`}>
					{/* Duplicate images for seamless loop */}
					{[...rightColumnImages, ...rightColumnImages].map((image, index) => (
						<div key={index} className={styles.imageContainer}>
							<img src={image.src || "/placeholder.svg"} alt={image.alt} className={styles.image} />
						</div>
					))}
				</div>
			</div> }
		</div>
	);
};

export default VerticalCarousel;
